import React, { useState, useEffect } from "react";
import Feedback from "./Feedback";
import "./Floaticons.css";
import mailData from '../data/mailData.js';
import { useMsal } from "@azure/msal-react";
function Floaticons() {
  const [username, setUsername] = React.useState();
  const { instance } = useMsal();
  const [level, setLevel] = useState("");
  const activeAccount = instance.getActiveAccount();
  return (
    <>
      <div className="float-wrap">
        {/* <div className="domain-role-sec"> */}
        {/* <div className="domain-role-arrow-row">
      <div className="domain-role-arrow-box">
       <img src="images/float-left-arrow.png" alt="arrow" className="float-left-arrow" />
       <img
        src="images/float-right-arrow.png"
        alt="arrow"
        className="float-right-arrow"
       />
      </div>
     </div> */}
        {/* <p>
      Domain: <span>E&E</span>{" "}
     </p>
     <p>
      Role: <span>Data Engineering</span>
      <br /> <span className="profici-level">({level})</span>{" "}
     </p> */}
        {/* </div> */}
        <div className="float-box box1">
          <p>
            <a href="https://app.powerbi.com/reportEmbed?reportId=d2ba8a6c-168c-4777-8e63-4d6691f10122&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Dashboard-new.png"}
                //src="images/Home/Dashboard-new.png"
                alt="icons"
                className="float-icons"
              />
              Dashboard
            </a>
          </p>
        </div>
        <div className="float-box box2">
          <p>
            <a href={`mailto:${mailData.adityacsoni};${mailData.nikhilapala};${mailData.ashwindeshpande}`}>
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Contact-us-new.png"}
                // src="images/Home/Contact-us-new.png"
                alt="icons"
                className="float-icons"
              />
              Contact us
            </a>
          </p>
        </div>
        <div className="float-box box3">
          <p>
            <a href="#">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Feedback-new.png"}
                // src="images/Home/Feedback-new.png"
                alt="icons"
                className="float-icons"
              />
              Feedback
            </a>
          </p>
        </div>
        <Feedback />
        <div className="float-box box4">
          <p>
            <a href="#" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Yammer-new.png"}
                // src="images/Home/Yammer-new.png"
                alt="icons"
                className="float-icons"
              />
              Yammer Community
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Floaticons;
